'use client' // Error components must be Client Components
import { useEffect } from 'react'
import { useTransitionToSuite } from '@/hooks'
import { SectionNotFound } from '@/components/project/SectionNotFound'

export default function Error({ error }: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  const { setStartTransition, setImgData } = useTransitionToSuite()

  useEffect(() => {
    setStartTransition(false)
    setImgData(null)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    // Log the error to an error reporting service
    console.error(error)
  }, [error])

  return (
    <div>
      <SectionNotFound  />
    </div>
  )
}
